import { render, staticRenderFns } from "./TrapTargetTable.vue?vue&type=template&id=21a0b9ed&"
import script from "./TrapTargetTable.vue?vue&type=script&lang=js&"
export * from "./TrapTargetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports